import { Country } from "lib/dayjs"

import { useAppSelector } from "store/hooks"

export const useCountry = (): Country => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  return (userProfile?.contractor?.country?.name ?? Country.US) as Country
}
